import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useMarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { useTopOfPageContextStore } from "@faire/retailer-visitor-shared/stores/ui/TopOfPageContextStore";
import { usePromoBanners } from "@faire/retailer-visitor-shared/stores/ui/usePromoBanners";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { useCallback } from "react";
export var useTopOfPageContent = function() {
    var isDesktopAndAbove = useViewport().isDesktopAndAbove;
    var isShowingCountdownBanner = useMarketStore([
        "isShowingCountdownBanner"
    ]).isShowingCountdownBanner;
    var promoBannerHeight = usePromoBanners().promoBannerHeight;
    var _useTopOfPageContextStore = _sliced_to_array(useTopOfPageContextStore([
        "height",
        "shouldKeepTopNavVisible"
    ]), 2), _useTopOfPageContextStore_ = _useTopOfPageContextStore[0], height = _useTopOfPageContextStore_.height, shouldKeepTopNavVisible = _useTopOfPageContextStore_.shouldKeepTopNavVisible, setStore = _useTopOfPageContextStore[1];
    var setHeaderHeight = useCallback(function(height) {
        if (height !== undefined) {
            setStore({
                height: height
            });
        }
    }, [
        setStore
    ]);
    var setShouldKeepTopNavVisible = useCallback(function(newValue) {
        setStore({
            shouldKeepTopNavVisible: newValue
        });
    }, [
        setStore
    ]);
    var headerPlusPromoBannerHeight = height + promoBannerHeight;
    return {
        headerHeight: height,
        headerPlusPromoBannerHeight: headerPlusPromoBannerHeight,
        heightWithHeaderOrMarketBanner: isShowingCountdownBanner && isDesktopAndAbove ? promoBannerHeight : height,
        heightWithoutPromoBannerExceptMarket: isShowingCountdownBanner && isDesktopAndAbove ? headerPlusPromoBannerHeight : height,
        setHeaderHeight: setHeaderHeight,
        setShouldKeepTopNavVisible: setShouldKeepTopNavVisible,
        shouldKeepTopNavVisible: shouldKeepTopNavVisible
    };
};
